const COLOR_CODES: Record<File['type'], string> = {
    pdf: '#D70015',
    jpg: '#33F',
    jpeg: '#33F',
    png: '#33F',
};

const FileIcon = ({type}: {type?: File['type']}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 21 26"
            width="30"
            height="30"
        >
            <path
                fill="#E9E9E9"
                d="M2.362 1.68c0-.888.72-1.609 1.61-1.609H15.25l2.848 2.994 2.832 2.96v18.183c0 .889-.72 1.609-1.609 1.609H3.972c-.89 0-1.61-.72-1.61-1.609V1.68Z"
            />
            <path fill="#D9D9D9" d="M20.931 6.038h-5.68l5.68 5.407V6.038Z" />
            <path fill="#7B7B7B" d="M15.253 6.038V.07l5.678 5.967h-5.678Z" />
            <rect
                width="14.776"
                height="9.216"
                x=".181"
                y="11.452"
                fill={COLOR_CODES[type || 'pdf']}
                rx="1.609"
            />
            <text x="1" y="18.5" fontSize="5px" fill="white">
                {type?.toUpperCase()}
            </text>
        </svg>
    );
};

export default FileIcon;
